// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"510":"9dd411f0","673":"c6ff44cf","766":"b2836a75","767":"d6fa0e16","899":"5320eabd"}[chunkId] + ".chunk.js";
};